import React, { useContext, useEffect, useState } from 'react'
import {
    Box, Button, Typography, IconButton, CircularProgress,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper,
    Divider,
} from '@mui/material';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../../Config';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import Context from '../../context/Context';
import DeleteConfirm from '../../Common/DeleteConfirm';
const DisplayRoles = () => {
    const { roles, getAllRoles,isConfirmDeleteModelOpen,setIsConfirmDeleteModelOpen,itemIdToDelete,
        confirmDelete  } = useContext(Context)
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState('')
    const handleAddClick = () => {
        navigate('/create-edit-roles')
    }
    const handleEditClick = (role) => {
        navigate('/create-edit-roles', { state: { role } })
    }
    const handleDelete = async () => {
        setIsConfirmDeleteModelOpen(false)
        setLoading(true)
        try {
            const response = await axios.delete(apiUrl + `/role/deleterole/${itemIdToDelete}`)
            if (response?.data?.status === true) {
                toast.success(response?.data?.message || 'Role deleted successfully')
                getAllRoles()
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || 'Error for delete roles')

        }
        finally {
            setLoading(false)
        }
    }

    const handlePermissions=(role)=>{
        navigate('/display-role-permissions',{state:{role}})
    }
    useEffect(() => {
        getAllRoles()
    }, [])

    return (
        <>
            <Box sx={{ backgroundColor: "", padding: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h3">Roles</Typography>
                    <Button
                        variant="contained"
                        sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
                        onClick={handleAddClick}
                    >
                        <Plus size={23} />
                        <Typography>Add Role</Typography>
                    </Button>
                </Box>

                <Divider sx={{ mb: 3 }} />


                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100px">
                        <CircularProgress />
                    </Box>
                ) : (
                    <TableContainer component={Paper} elevation={1}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>S.No</strong></TableCell>
                                    <TableCell><strong>Name</strong></TableCell>

                                    <TableCell><strong>Is Active</strong></TableCell>

                                    <TableCell align='right'><strong>Actions</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {roles.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            No Role found.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    roles.map((role, index) => (
                                        <TableRow key={role.id}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{role?.name}</TableCell>
                                            <TableCell>{role?.isActive === true ? "true" : "false"}</TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
                                                    <IconButton onClick={() => handleEditClick(role)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton color="error" onClick={() => confirmDelete(role.id)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                    <Button
                                                        variant="contained"
                                                        sx={{  display: "flex", gap: 1 }}
                                                        onClick={()=>handlePermissions(role)}
                                                    >
                                                    
                                                        <Typography>Permissions</Typography>
                                                    </Button>

                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                {errors && <Typography variant='body2' color='error'>{errors}</Typography>}
            </Box>
             <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />
        </>
    )
}

export default DisplayRoles